import { Autocomplete, TextField } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from './styles.module.css'
import { useContext, useEffect, useState } from 'react';
import { RelatoriosContext } from '../RelatoriosContext';
import { buscarCombosRelatorios } from '../../../services/auth.service';

const TabFiltros = () => {
  const { dadosFiltros, setDadosFiltros } = useContext(RelatoriosContext)
  const [combos, setCombos] = useState([])

  useEffect(() => {
    const fetch = async () => {
      const listaCombos = await buscarCombosRelatorios();
      setCombos(listaCombos.combos)
      console.clear()
    }

    fetch()
  }, [])

  useEffect(() => {
    console.clear()
  }, [combos])

  const tipos = [
    { id: 'text', value: 'TextField' },
    { id: 'autocomplete', value: 'AutoComplete' },
    { id: 'autocomplete_dependencia', value: 'AutoComplete com Dependência' },
    { id: 'data', value: 'Data' }
  ]

  const handleAdd = () => {
    const allFieldsFilled = dadosFiltros.every(item => item.nome && item.variavel && item.script);

    if (allFieldsFilled) {
      setDadosFiltros([...dadosFiltros, { nome: '', variavel: '$F{}', script: '' }]);
    } else {
      alert('Por favor, preencha todos os campos antes de adicionar uma nova linha.');
    }
  }

  const handleDelete = (index) => {
    const newList = [...dadosFiltros];
    newList.splice(index, 1);
    setDadosFiltros(newList);
  }

  const handleChange = (index, field, value) => {
    const newList = [...dadosFiltros];
    newList[index][field] = value;
    setDadosFiltros(newList);
  };

  const handleAutocompleteChange = (field, value, index) => {
    setDadosFiltros(prev => {
      const newList = [...prev];
      switch (field) {
        case 'tipoDado':
          newList[index]['codCombo'] = null;
          newList[index]['codComboPai'] = null;
          newList[index]['nomeComboPai'] = null;
          newList[index][field] = value?.id || null;
          break;
          case 'codCombo':
          newList[index]['codComboPai'] = null;
          newList[index]['nomeComboPai'] = null;
          newList[index][field] = value?.cod_combo || null;
          break;
        case 'codComboPai':
          newList[index][field] = value?.cod_combo || null;
          const nome = combos.find(item => item.cod_combo === value?.cod_combo)
          newList[index]['nomeComboPai'] = nome.descricao_combo || null;
          break;

        default:
          break;
      }
      return newList;
    });
  };
  return (
    <>
      <AddCircleOutlineIcon className={styles.add_button} onClick={handleAdd} />
      <div className={styles.container}>
        {dadosFiltros.map((item, index) => {
          return (
            <div className={styles.row} key={item + index}>
              <TextField
                label='Nome'
                value={item.nome}
                sx={{ width: '18rem' }}
                onChange={(e) => handleChange(index, 'nome', e.target.value)}
              />
              <TextField
                label='Variável'
                value={item.variavel}
                sx={{ width: '15rem' }}
                onChange={(e) => handleChange(index, 'variavel', e.target.value)}
              />
              <TextField
                label='Script'
                sx={{ width: '20rem' }}
                value={item.script}
                onChange={(e) => handleChange(index, 'script', e.target.value)}
              />

              <Autocomplete
                sx={{ width: '15rem' }}
                options={tipos}
                getOptionLabel={(option) => option.value}
                value={tipos.find(tipo => tipo?.id === item?.tipoDado)}
                isOptionEqualToValue={(option, value) => option.id === value?.tipoDado}
                onChange={(_, value) => handleAutocompleteChange('tipoDado', value, index)}
                renderInput={(params) => <TextField {...params} label="Tipo" />}
              />

              {(dadosFiltros[index].tipoDado === 'autocomplete' || dadosFiltros[index].tipoDado === 'autocomplete_dependencia')
                ? <Autocomplete
                  sx={{ width: '15rem' }}
                  options={combos}
                  getOptionLabel={(option) => option.descricao_combo}
                  value={combos.find(combo => combo.cod_combo === item.codCombo) || null}
                  noOptionsText='Nenhum combo encontrado'
                  isOptionEqualToValue={(option, value) => option.cod_combo === value?.codCombo}
                  onChange={(_, value) => handleAutocompleteChange('codCombo', value, index)}
                  renderInput={(params) => <TextField {...params} label="Tipo da Combo" />}
                />
                : ''}

              {dadosFiltros[index].tipoDado === 'autocomplete_dependencia'
                ? <Autocomplete
                  sx={{ width: '15rem' }}
                  options={combos}
                  getOptionLabel={(option) => option.descricao_combo}
                  value={combos.find(combo => combo.cod_combo === item.codComboPai) || null}
                  noOptionsText='Nenhum combo encontrado'
                  isOptionEqualToValue={(option, value) => option.cod_combo === value?.codComboPai}
                  onChange={(_, value) => handleAutocompleteChange('codComboPai', value, index)}
                  renderInput={(params) => <TextField {...params} label="Combo Pai" />}
                />
                : ''}
              <DeleteIcon className={styles.trash_button} onClick={() => handleDelete(index)} />
            </div>
          )
        })}
      </div>
    </>
  )
}

export default TabFiltros